goog.provide("shadow.js.shim.module$dayjs$locale$tr");
goog.provide("module$shadow_js_shim_module$dayjs$locale$tr");
shadow.js.shim.module$dayjs$locale$tr = shadow.js.nativeProvides["dayjs/locale/tr"] = require("dayjs/locale/tr");
module$shadow_js_shim_module$dayjs$locale$tr.default = shadow.js.shim.module$dayjs$locale$tr;
